import { Injectable, signal } from '@angular/core';

export interface ConfirmOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  /** Acción destructiva (cancelar, eliminar): botón rojo. */
  danger?: boolean;
}

/**
 * Confirmación con el diseño de la tienda en lugar del confirm() del navegador.
 * La pinta ConfirmDialogComponent (en los layouts, junto a los toasts).
 */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  readonly current = signal<(ConfirmOptions & { resolve: (ok: boolean) => void }) | null>(null);

  ask(options: ConfirmOptions): Promise<boolean> {
    this.current()?.resolve(false);
    return new Promise((resolve) => this.current.set({ ...options, resolve }));
  }

  answer(ok: boolean): void {
    const pending = this.current();
    this.current.set(null);
    pending?.resolve(ok);
  }
}
